import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';


@Component({
  selector: 'app-dropdown-field',
  template: `
      <div 
        #trigger="matMenuTrigger"
        [matMenuTriggerFor]="menu"
        (menuClosed)="onMenuClosed()"
        class="rounded-md py-3 pl-0 minw-200-px flex justify-between items-center h-30-px cursor-pointer"
      >
      <span [ngClass]="textClass" class="barlow text-xs font-lg p-5 italic"> 
        {{selectedText || placeholder}}
      </span>
        <span 
          [ngClass]="trigger.menuOpen ? openArrowClass : closeArrowClass"
          class="material-icons"
        >
          {{ trigger.menuOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}
        </span>
      </div>
      <mat-menu #menu="matMenu">
        <button 
          mat-menu-item 
          class="tracking-wide focus:outline-none italic text-xs"
          *ngFor="let option of options"
          (click)="onSelect(option)"
        >
          {{option.label}}
        </button>
      </mat-menu>
    `,
  styleUrl: './custom-dropdown.component.scss',
  standalone: true,
  imports: [CommonModule, MatMenuModule]
})
export class DropdownFieldComponent {
  @Input() options: {label: string, value: any}[] = [];
  @Input() placeholder = String('== Select an option ==');
  @Input() selectedText = String("");
  @Input() openArrowClass  = 'orange-text';  
  @Input() closeArrowClass = 'violet-text'; 
  @Input() textClass = 'text-black';
  @Input() onTouched: () => void = () => {};
  @Output() selectionChange = new EventEmitter<{label: string, value: any}>();

  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

  onSelect(option: {label: string, value: any}) {
    this.selectedText = option.label;
    this.selectionChange.emit(option);
  }

  onMenuClosed() {
    if (!this.selectedText) {
      this.onTouched();
    }
  }
}
